<template>
  <section v-if="getIsMaster || getIsSuperUser">
    <v-tabs dark slider-color="red">
      <v-tab
        v-for="tab in tabs"
        :key="`tab-${tab.route}`"
        ripple
        :to="{ name: tab.route }"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-layout>
      <v-btn color="info" @click="downloadVotingExcel">
        Download Voting
      </v-btn>
      <v-btn color="info" @click="downloadVotingExcelIndividual">
        Download Individual Voting
      </v-btn>
    </v-layout>
    <v-card class="px-4 py-4">
      <router-view />
    </v-card>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AwardsVoting',
  data () {
    return {
      tabs: [
        {
          name: 'Voting step one results',
          route: 'awards-voting-step-one'
        },
        {
          name: 'Voting step two results',
          route: 'awards-voting-step-two'
        },
        {
          name: 'step one individual results',
          route: 'awards-voting-step-one-individual'
        },
        {
          name: 'step two individual results',
          route: 'awards-voting-step-two-individual'
        },
        {
          name: 'Votes',
          route: 'awards-voting-votes'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['getIsMaster', 'getIsSuperUser'])
  },
  methods: {
    ...mapActions([
      'downloadVotingExcelIndividual',
      'downloadVotingExcel'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Awards/Voting/index.vue